import JSXComponent from "../../dist/jsx-render/JSXComponent";
import dom from "../../dist/jsx-render/dom";

export type ButtonComponentProps = {
    text?: string;
    action: any;

    additionalCssClasses?: string;
    children?: any;
    altText?: string;
    dataAttributes?: any[];
}

export class ButtonComponent extends JSXComponent {
    props: ButtonComponentProps;
    element: HTMLElement;

    constructor(props: ButtonComponentProps) { super(props); }

    render() {
        this.element =
            <div className={"icon"
                + (this.props.additionalCssClasses ? (" " + this.props.additionalCssClasses) : "")} title={this.props.altText} >
                {this.props.text ? this.props.text : ""}
                {...this.props.children}
            </div>;

        if (this.props.dataAttributes && this.props.dataAttributes.length > 0) {
            this.props.dataAttributes.forEach((attr, index) => { this.element.setAttribute(Object.keys(attr)[index], attr[Object.keys(attr)[index]]) })
        }

        this.element.addEventListener('click', this.props.action);
        return this.element;
    }
}